// @generated by protoc-gen-es v2.15.0 with parameter "target=ts,import_extension=js"
// @generated from file console/admin/v1/mapping.proto (package console.admin.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { OperatorRole, Product } from "../../common/v1/common_pb.js";
import { file_console_common_v1_common } from "../../common/v1/common_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file console/admin/v1/mapping.proto.
 */
export const file_console_admin_v1_mapping: GenFile = /*@__PURE__*/
  fileDesc("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", [file_console_common_v1_common]);

/**
 * @generated from message console.admin.v1.GroupMapping
 */
export type GroupMapping = Message<"console.admin.v1.GroupMapping"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string org_id = 2;
   */
  orgId: string;

  /**
   * @generated from field: string idp_group_id = 3;
   */
  idpGroupId: string;

  /**
   * @generated from field: string idp_group_name = 4;
   */
  idpGroupName: string;

  /**
   * UNSPECIFIED leaves the role as set manually.
   *
   * @generated from field: console.common.v1.OperatorRole operator_role = 5;
   */
  operatorRole: OperatorRole;

  /**
   * @generated from field: repeated console.common.v1.Product restricted_products = 6;
   */
  restrictedProducts: Product[];

  /**
   * Unused in deciding a role: unrestricted beats law enforcement when a
   * person is in more than one mapped group. Kept for ordering a list.
   *
   * @generated from field: int32 priority = 7;
   */
  priority: number;
};

/**
 * Describes the message console.admin.v1.GroupMapping.
 * Use `create(GroupMappingSchema)` to create a new message.
 */
export const GroupMappingSchema: GenMessage<GroupMapping> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_mapping, 0);

/**
 * @generated from message console.admin.v1.ListGroupMappingsRequest
 */
export type ListGroupMappingsRequest = Message<"console.admin.v1.ListGroupMappingsRequest"> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string;
};

/**
 * Describes the message console.admin.v1.ListGroupMappingsRequest.
 * Use `create(ListGroupMappingsRequestSchema)` to create a new message.
 */
export const ListGroupMappingsRequestSchema: GenMessage<ListGroupMappingsRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_mapping, 1);

/**
 * @generated from message console.admin.v1.ListGroupMappingsResponse
 */
export type ListGroupMappingsResponse = Message<"console.admin.v1.ListGroupMappingsResponse"> & {
  /**
   * @generated from field: repeated console.admin.v1.GroupMapping mappings = 1;
   */
  mappings: GroupMapping[];

  /**
   * Groups the directory reports that have no mapping yet, for the picker.
   *
   * @generated from field: repeated console.admin.v1.DirectoryGroup unmapped_groups = 2;
   */
  unmappedGroups: DirectoryGroup[];

  /**
   * The directory's groups could not be read; `unmapped_groups` is empty
   * for that reason, not because there are none.
   *
   * @generated from field: bool directory_unread = 3;
   */
  directoryUnread: boolean;
};

/**
 * Describes the message console.admin.v1.ListGroupMappingsResponse.
 * Use `create(ListGroupMappingsResponseSchema)` to create a new message.
 */
export const ListGroupMappingsResponseSchema: GenMessage<ListGroupMappingsResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_mapping, 2);

/**
 * @generated from message console.admin.v1.DirectoryGroup
 */
export type DirectoryGroup = Message<"console.admin.v1.DirectoryGroup"> & {
  /**
   * @generated from field: string idp_group_id = 1;
   */
  idpGroupId: string;

  /**
   * @generated from field: string idp_group_name = 2;
   */
  idpGroupName: string;
};

/**
 * Describes the message console.admin.v1.DirectoryGroup.
 * Use `create(DirectoryGroupSchema)` to create a new message.
 */
export const DirectoryGroupSchema: GenMessage<DirectoryGroup> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_mapping, 3);

/**
 * @generated from message console.admin.v1.SetGroupMappingRequest
 */
export type SetGroupMappingRequest = Message<"console.admin.v1.SetGroupMappingRequest"> & {
  /**
   * @generated from field: console.admin.v1.GroupMapping mapping = 1;
   */
  mapping?: GroupMapping | undefined;
};

/**
 * Describes the message console.admin.v1.SetGroupMappingRequest.
 * Use `create(SetGroupMappingRequestSchema)` to create a new message.
 */
export const SetGroupMappingRequestSchema: GenMessage<SetGroupMappingRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_mapping, 4);

/**
 * @generated from message console.admin.v1.SetGroupMappingResponse
 */
export type SetGroupMappingResponse = Message<"console.admin.v1.SetGroupMappingResponse"> & {
  /**
   * @generated from field: console.admin.v1.GroupMapping mapping = 1;
   */
  mapping?: GroupMapping | undefined;
};

/**
 * Describes the message console.admin.v1.SetGroupMappingResponse.
 * Use `create(SetGroupMappingResponseSchema)` to create a new message.
 */
export const SetGroupMappingResponseSchema: GenMessage<SetGroupMappingResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_mapping, 5);

/**
 * @generated from message console.admin.v1.DeleteGroupMappingRequest
 */
export type DeleteGroupMappingRequest = Message<"console.admin.v1.DeleteGroupMappingRequest"> & {
  /**
   * @generated from field: string mapping_id = 1;
   */
  mappingId: string;
};

/**
 * Describes the message console.admin.v1.DeleteGroupMappingRequest.
 * Use `create(DeleteGroupMappingRequestSchema)` to create a new message.
 */
export const DeleteGroupMappingRequestSchema: GenMessage<DeleteGroupMappingRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_mapping, 6);

/**
 * @generated from message console.admin.v1.DeleteGroupMappingResponse
 */
export type DeleteGroupMappingResponse = Message<"console.admin.v1.DeleteGroupMappingResponse"> & {
};

/**
 * Describes the message console.admin.v1.DeleteGroupMappingResponse.
 * Use `create(DeleteGroupMappingResponseSchema)` to create a new message.
 */
export const DeleteGroupMappingResponseSchema: GenMessage<DeleteGroupMappingResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_mapping, 7);

/**
 * @generated from message console.admin.v1.PreviewGroupMappingRequest
 */
export type PreviewGroupMappingRequest = Message<"console.admin.v1.PreviewGroupMappingRequest"> & {
  /**
   * @generated from field: console.admin.v1.GroupMapping mapping = 1;
   */
  mapping?: GroupMapping | undefined;
};

/**
 * Describes the message console.admin.v1.PreviewGroupMappingRequest.
 * Use `create(PreviewGroupMappingRequestSchema)` to create a new message.
 */
export const PreviewGroupMappingRequestSchema: GenMessage<PreviewGroupMappingRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_mapping, 8);

/**
 * @generated from message console.admin.v1.PreviewGroupMappingResponse
 */
export type PreviewGroupMappingResponse = Message<"console.admin.v1.PreviewGroupMappingResponse"> & {
  /**
   * @generated from field: repeated console.admin.v1.UserChange changes = 1;
   */
  changes: UserChange[];
};

/**
 * Describes the message console.admin.v1.PreviewGroupMappingResponse.
 * Use `create(PreviewGroupMappingResponseSchema)` to create a new message.
 */
export const PreviewGroupMappingResponseSchema: GenMessage<PreviewGroupMappingResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_mapping, 9);

/**
 * @generated from message console.admin.v1.UserChange
 */
export type UserChange = Message<"console.admin.v1.UserChange"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string display_name = 2;
   */
  displayName: string;

  /**
   * @generated from field: console.common.v1.OperatorRole role_before = 3;
   */
  roleBefore: OperatorRole;

  /**
   * @generated from field: console.common.v1.OperatorRole role_after = 4;
   */
  roleAfter: OperatorRole;

  /**
   * @generated from field: repeated console.common.v1.Product restricted_before = 5;
   */
  restrictedBefore: Product[];

  /**
   * @generated from field: repeated console.common.v1.Product restricted_after = 6;
   */
  restrictedAfter: Product[];
};

/**
 * Describes the message console.admin.v1.UserChange.
 * Use `create(UserChangeSchema)` to create a new message.
 */
export const UserChangeSchema: GenMessage<UserChange> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_mapping, 10);

/**
 * Directory group mappings, for organizations with group provisioning
 * (FEATURE_DIRECTORY_SYNC). A mapping turns membership of a directory group
 * into an operator role and an optional list of products that group may not
 * use. Someone in a mapped group takes a free seat as they arrive; someone
 * in no mapped group waits for an administrator to give them one.
 *
 * @generated from service console.admin.v1.GroupMappingService
 */
export const GroupMappingService: GenService<{
  /**
   * @generated from rpc console.admin.v1.GroupMappingService.ListGroupMappings
   */
  listGroupMappings: {
    methodKind: "unary";
    input: typeof ListGroupMappingsRequestSchema;
    output: typeof ListGroupMappingsResponseSchema;
  },
  /**
   * @generated from rpc console.admin.v1.GroupMappingService.SetGroupMapping
   */
  setGroupMapping: {
    methodKind: "unary";
    input: typeof SetGroupMappingRequestSchema;
    output: typeof SetGroupMappingResponseSchema;
  },
  /**
   * @generated from rpc console.admin.v1.GroupMappingService.DeleteGroupMapping
   */
  deleteGroupMapping: {
    methodKind: "unary";
    input: typeof DeleteGroupMappingRequestSchema;
    output: typeof DeleteGroupMappingResponseSchema;
  },
  /**
   * Who would change, before saving.
   *
   * @generated from rpc console.admin.v1.GroupMappingService.PreviewGroupMapping
   */
  previewGroupMapping: {
    methodKind: "unary";
    input: typeof PreviewGroupMappingRequestSchema;
    output: typeof PreviewGroupMappingResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_console_admin_v1_mapping, 0);

